import { render, staticRenderFns } from "./sp-tab.vue?vue&type=template&id=690d640a"
import script from "./sp-tab.vue?vue&type=script&lang=js"
export * from "./sp-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports